<template>
  <div>
    <v-row>
      <!-- Accounts List -->
      <v-col cols="12" sm="6" lg="3">
        <v-autocomplete
          :items="accountsListOptions"
          v-model="selectedFilters.accountOption"
          label="Company Name(Account#)"
          dense
          outlined
          class="cursor_pointer"
        ></v-autocomplete>
      </v-col>
      <!-- Pick Time Frame -->
      <v-col cols="12" sm="6" lg="2">
        <v-autocomplete
          :items="timeFrameListOptions"
          v-model="selectedFilters.timeFrameOption"
          label="Pick Timeframe"
          dense
          outlined
          @change="filterChange"
          class="cursor_pointer"
        ></v-autocomplete>
      </v-col>
      <!-- FROM: Date Range -->
      <v-col cols="12" sm="6" lg="2">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedDate1Formatted"
              label="Start Date"
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
              dense
              :disabled="datePickerDisable"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dates[0]"
            no-title
            @input="filterChange"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <p
        class="pa-0 ma-0 mt-5"
        :class="datePickerDisable ? 'text--disabled' : 'text--primary'"
      >
        TO
      </p>
      <!-- TO: Date Range -->
      <v-col cols="12" sm="6" lg="2">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedDate2Formatted"
              label="End Date"
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
              dense
              :disabled="datePickerDisable"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dates[1]"
            no-title
            @input="filterChange"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <!-- Go Button -->
      <v-col cols="12" sm="6" lg="1">
        <v-btn
          depressed
          color="success"
          :disabled="goButtonDisable"
          @click="goButtonEvent"
        >
          Go
        </v-btn>
      </v-col>
      <!-- Export Data Button -->
      <v-col cols="12" sm="6" lg="1">
        <v-btn depressed color="primary" @click="exportReports">
          EXPORT DATA <v-icon class="pl-2">mdi-cloud-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <line-chart
      :key="renderChat"
      v-if="displayChart === true"
      :chartdata="chartData"
    ></line-chart>
    <h1 v-else class="title">{{ graphLoadingHint }}</h1>
  </div>
</template>

<script>
import API from "../../api/dashboardReports";
import { dashboardReportsMixins } from "../../mixins/dashboardReportsMixins";
export default {
  components: {
    "line-chart": () => import("./LineChart.vue"),
  },
  created() {
    // Filtering accounts frame options
    const userAccounts = this.$store.getters["users/getUserAccounts"];

    this.accountList = userAccounts.filter(
      (account) => account.approvedBy && account.approvedBy.length > 0
    );
    this.accountList.map((each) => {
      this.accountsListOptions.push(`${each.companyName}(${each.accountId})`);
    });

    // Fetching previous filters
    const adminReportsFilters =
      this.$store.getters["admin/getAdminReportsFilters"];

    if (Object.keys(adminReportsFilters).length) {
      this.selectedFilters = adminReportsFilters;
      this.disablePreviousFilters();
      if (this.selectedFilters.timeFrameOption === "Time Range") {
        this.dates = this.selectedFilters.dates;
        if (this.dates.length === 2) {
          this.datePickerDisable = false;
          this.goButtonDisable = false;
        } else if (this.dates.length === 1) {
          this.datePickerDisable = false;
        }
      }
    } else {
      this.selectedFilters = {
        accountOption: "All Accounts",
        timeFrameOption: "Today",
      };
      this.$store.commit(
        "admin/SET_ADMIN_REPORTS_FILTERS",
        this.selectedFilters
      );
    }
    // Fetching previous filters graph data
    const graphData = this.$store.getters["admin/getGraphData"];
    if (Object.keys(graphData).length) {
      this.displayChart = true;
    } else {
      this.filterChange();
    }
  },
  data() {
    return {
      accountsListOptions: ["All Accounts"],
      chartData: this.$store.getters["admin/getGraphData"],
      dates: [],
      datePickerDisable: true,
      displayChart: false,
      exportInfo: this.$store.getters["admin/getAdminSummaryReports"],
      goButtonDisable: true,
      goButtonClicked: false,
      graphTitle: "",
      graphLoadingHint: "Loading Graph...",
      menu: false,
      menu1: false,
      renderChat: false,
      selectedFilters: {},
      timeFrameListOptions: ["Today", "Time Range"],
    };
  },
  mixins: [dashboardReportsMixins],
  methods: {
    disablePreviousFilters() {
      // For specific account selection pushing since inception into time frame options
      if (this.selectedFilters.accountOption === "All Accounts") {
        const index = this.timeFrameListOptions.indexOf("Since Inception");
        if (index > -1) {
          this.timeFrameListOptions = ["Today", "Time Range"];
          this.selectedFilters.timeFrameOption =
            this.selectedFilters.timeFrameOption !== "Since Inception"
              ? this.selectedFilters.timeFrameOption
              : "Today";
        }
      } else {
        this.timeFrameListOptions.push("Since Inception");
      }
      // Timeframe filter is not TimeRange disbale go button
      if (this.selectedFilters.timeFrameOption !== "Time Range") {
        this.datePickerDisable = true;
        this.goButtonDisable = true;
        this.dates = [];
        this.selectedFilters.dates = [];
      }
    },
    async exportReports() {
      let data = {
        accountOption: this.selectedFilters.accountOption,
        timeFrameOption: this.selectedFilters.timeFrameOption,
        counts: this.$store.getters["admin/getExportData"],
      };
      if (data.timeFrameOption === "Time Range") data.dates = this.dates;
      await this.exportAdminReports(data);
      this.showSnack(`Exported data successfully!`, false);
    },
    async filterChange() {
      this.graphLoadingHint = "Loading Graph...";
      // To remove previous filters
      this.disablePreviousFilters();
      //Based on time frame preparing payload
      let payload = this.preparePayload();

      const graphSubTitle = payload.graphTitle;
      delete payload.graphTitle;

      if (payload.hasOwnProperty("timeframe")) {
        // Store modified filters
        this.$store.commit(
          "admin/SET_ADMIN_REPORTS_FILTERS",
          this.selectedFilters
        );

        this.renderChat = false;
        this.displayChart = false;
        // To fetch All accounts reports

        if (this.selectedFilters.accountOption === "All Accounts") {
          await API.fetchAllAccountsReports(payload)
            .then(async (response) => {
              const result = await this.preparingReports(response);

              // Store export data
              this.exportInfo = result.exportMetrics;
              this.$store.commit("admin/SET_EXPORT_DATA", this.exportInfo);

              // Plot graph
              result.graphMetrics.graphTitle = `${result.graphMetrics.graphTitle} ${graphSubTitle}`;
              this.chartData = result.graphMetrics;
              this.displayChart = true;
              // Store grph data
              this.$store.commit("admin/SET_GRAPH_DATA", this.chartData);
            })
            .catch((error) => {
              console.error(
                `[AdminFilters] - fetch reports - error ${JSON.stringify(
                  error
                )}`
              );
              this.graphLoadingHint = "Something went wrong. Please try again.";
              this.showSnack(
                `Fetching reports got failed! Please try again!`,
                true
              );
            });
        }
        // To fetch specific account reports
        else {
          payload.accountId = this.filterAccountId(
            this.selectedFilters.accountOption
          );
          await API.fetchAccountReports(payload)
            .then(async (response) => {
              const result = await this.preparingReports(response);

              // Store export data
              this.exportInfo = result.exportMetrics;
              this.$store.commit("admin/SET_EXPORT_DATA", this.exportInfo);

              // Plot graph
              result.graphMetrics.graphTitle = `${result.graphMetrics.graphTitle} ${graphSubTitle}`;
              this.chartData = result.graphMetrics;
              this.displayChart = true;
              // Store grph data
              this.$store.commit("admin/SET_GRAPH_DATA", this.chartData);
            })
            .catch((error) => {
              console.error(
                `[AdminFilters] - fetch reports - error ${JSON.stringify(
                  error
                )}`
              );
              this.graphLoadingHint = "Something went wrong. Please try again.";
              this.showSnack(
                `Fetching reports got failed! Please try again!`,
                true
              );
            });
        }
      }
    },
    goButtonEvent() {
      this.goButtonClicked = true;
      this.filterChange();
    },
  },
  watch: {
    "selectedFilters.accountOption"(newVal, oldVal) {
      if (oldVal && newVal && oldVal !== newVal) {
        this.selectedFilters.timeFrameOption = "";
        if (this.selectedFilters.accountOption === "All Accounts") {
          const index = this.timeFrameListOptions.indexOf("Since Inception");
          if (index > -1) {
            this.timeFrameListOptions = ["Today", "Time Range"];
          }
        } else {
          this.timeFrameListOptions.push("Since Inception");
        }
      }
    },
  },
};
</script>

<style scoped>
.cursor_pointer input {
  cursor: pointer;
}
</style>